import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "admin-hint"
}
const _hoisted_2 = {
  key: 2,
  class: "admin-hint"
}
const _hoisted_3 = {
  key: 3,
  class: "admin-tests-list"
}
const _hoisted_4 = { class: "admin-test-main" }
const _hoisted_5 = { class: "admin-test-assignments" }
const _hoisted_6 = {
  key: "assign-loading",
  class: "admin-hint"
}
const _hoisted_7 = { class: "admin-assignment-login" }
const _hoisted_8 = { class: "admin-assignment-status-row" }
const _hoisted_9 = {
  key: 0,
  class: "admin-assignment-status admin-assignment-status--passed"
}
const _hoisted_10 = {
  key: 1,
  class: "admin-assignment-status admin-assignment-status--draft"
}
const _hoisted_11 = {
  key: 2,
  class: "admin-assignment-status admin-assignment-status--failed"
}
const _hoisted_12 = {
  key: 3,
  class: "admin-assignment-status admin-assignment-status--none"
}
const _hoisted_13 = { class: "admin-assignment-attempts" }
const _hoisted_14 = {
  key: 4,
  class: "admin-assignment-score"
}
const _hoisted_15 = { class: "admin-assignment-actions" }
const _hoisted_16 = {
  key: "assign-filter-empty",
  class: "admin-hint"
}
const _hoisted_17 = {
  key: "assign-none",
  class: "admin-hint"
}
const _hoisted_18 = {
  key: 0,
  class: "admin-hint"
}
const _hoisted_19 = {
  key: 1,
  class: "admin-hint"
}
const _hoisted_20 = { class: "admin-user-pick-login" }
const _hoisted_21 = {
  key: 0,
  class: "admin-hint"
}
const _hoisted_22 = { class: "admin-modal-actions" }
const _hoisted_23 = {
  key: 0,
  class: "admin-hint"
}
const _hoisted_24 = { class: "admin-modal-actions" }
const _hoisted_25 = {
  key: 0,
  class: "admin-hint"
}
const _hoisted_26 = {
  key: 0,
  class: "admin-question-form admin-card"
}
const _hoisted_27 = { class: "admin-modal-actions" }
const _hoisted_28 = {
  key: 2,
  class: "admin-questions-list"
}
const _hoisted_29 = { class: "admin-question-header" }
const _hoisted_30 = { class: "admin-question-title" }
const _hoisted_31 = {
  key: 0,
  class: "admin-badge"
}
const _hoisted_32 = { class: "admin-question-order" }
const _hoisted_33 = { class: "admin-question-actions" }
const _hoisted_34 = {
  key: 0,
  class: "admin-question-form admin-edit-inline"
}
const _hoisted_35 = { class: "admin-answers-list" }
const _hoisted_36 = { class: "admin-answer-text" }
const _hoisted_37 = {
  key: 0,
  class: "admin-badge correct"
}
const _hoisted_38 = {
  key: 0,
  class: "admin-answer-row admin-add-answer"
}
const _hoisted_39 = {
  key: 3,
  class: "admin-hint"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageHeaderWithMenu = _resolveComponent("PageHeaderWithMenu")!
  const _component_ion_refresher_content = _resolveComponent("ion-refresher-content")!
  const _component_ion_refresher = _resolveComponent("ion-refresher")!
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_searchbar = _resolveComponent("ion-searchbar")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_checkbox = _resolveComponent("ion-checkbox")!
  const _component_ion_footer = _resolveComponent("ion-footer")!
  const _component_ion_modal = _resolveComponent("ion-modal")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_PageHeaderWithMenu, {
        title: "Тестирование",
        scrolled: _ctx.headerScrolled
      }, null, 8, ["scrolled"]),
      _createVNode(_component_ion_content, {
        class: _normalizeClass([_ctx.isMobile ? 'main-background' : 'liga-web-background']),
        fullscreen: true,
        onIonScroll: _ctx.onContentScroll
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_refresher, {
            slot: "fixed",
            onIonRefresh: _cache[0] || (_cache[0] = ($event: any) => (_ctx.loadTests($event)))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_refresher_content, { refreshingSpinner: "bubbles" })
            ]),
            _: 1
          }),
          _withDirectives(_createVNode(_component_ion_card, { class: "admin-card" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_card_header, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_card_title, null, {
                    default: _withCtx(() => [...(_cache[38] || (_cache[38] = [
                      _createTextVNode("Создать тест", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_ion_buttons, { slot: "end" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        fill: "clear",
                        size: "small",
                        class: "admin-card-btn",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showCreateForm = false))
                      }, {
                        default: _withCtx(() => [...(_cache[39] || (_cache[39] = [
                          _createTextVNode("Свернуть", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_card_content, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_input, {
                        label: "Название",
                        "label-placement": "stacked",
                        modelValue: _ctx.newTest.name,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newTest.name) = $event)),
                        placeholder: "Название теста"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_input, {
                        label: "Описание (необязательно)",
                        "label-placement": "stacked",
                        modelValue: _ctx.newTest.description,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newTest.description) = $event)),
                        placeholder: "Описание"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_input, {
                        label: "Порог успешности (%)",
                        "label-placement": "stacked",
                        type: "number",
                        modelValue: _ctx.newTest.passingThreshold,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.newTest.passingThreshold) = $event)),
                        modelModifiers: { number: true },
                        min: "0",
                        max: "100"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_input, {
                        label: "Макс. попыток (пусто = без ограничения)",
                        "label-placement": "stacked",
                        type: "number",
                        modelValue: _ctx.newTest.maxAttempts,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.newTest.maxAttempts) = $event)),
                        modelModifiers: { number: true },
                        placeholder: "Пусто"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_input, {
                        label: "Время на прохождение (ЧЧ:ММ, пусто = без ограничения)",
                        "label-placement": "stacked",
                        "model-value": (_ctx.newTest.durationForm as unknown as number),
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = (v) => _ctx.onNewTestDurationInput(v)),
                        placeholder: "00:00",
                        maxlength: 5
                      }, null, 8, ["model-value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_select, {
                        label: "Роли при успешном прохождении",
                        "label-placement": "stacked",
                        modelValue: _ctx.newTest.roleNames,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.newTest.roleNames) = $event)),
                        multiple: "",
                        interface: "popover",
                        mode: "ios",
                        placeholder: "Выберите роли"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allAuthorities, (a) => {
                            return (_openBlock(), _createBlock(_component_ion_select_option, {
                              key: a.name,
                              value: a.name
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(a.description || a.name), 1)
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_button, {
                    expand: "block",
                    class: "admin-primary-btn",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.createTest())),
                    disabled: !_ctx.newTest.name?.trim() || _ctx.creating
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.creating ? 'Создание…' : 'Создать тест'), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled"]),
                  _createVNode(_component_ion_button, {
                    expand: "block",
                    fill: "outline",
                    size: "small",
                    class: "admin-outline-btn",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showCreateForm = false))
                  }, {
                    default: _withCtx(() => [...(_cache[40] || (_cache[40] = [
                      _createTextVNode("Отмена", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 512), [
            [_vShow, _ctx.showCreateForm]
          ]),
          _createVNode(_component_ion_card, { class: "admin-card" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_card_header, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_card_title, null, {
                    default: _withCtx(() => [...(_cache[41] || (_cache[41] = [
                      _createTextVNode("Список тестов", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_card_content, null, {
                default: _withCtx(() => [
                  (!_ctx.showCreateForm)
                    ? (_openBlock(), _createBlock(_component_ion_button, {
                        key: 0,
                        expand: "block",
                        class: "admin-primary-btn",
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.showCreateForm = true))
                      }, {
                        default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
                          _createTextVNode("+ Создать тест", -1)
                        ]))]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.loading)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_1, "Загрузка…"))
                    : (!_ctx.tests.length)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_2, "Тестов пока нет."))
                      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tests, (t) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: t.id,
                              class: "admin-test-row"
                            }, [
                              _createElementVNode("div", _hoisted_4, [
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => [
                                    _createElementVNode("h2", null, _toDisplayString(t.name), 1),
                                    _createElementVNode("p", null, "Порог: " + _toDisplayString(t.passingThreshold) + "% · Попыток: " + _toDisplayString(t.maxAttempts ?? '∞') + " · Время: " + _toDisplayString(_ctx.formatDurationDisplay(t.durationMinutes)), 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_ion_button, {
                                  fill: "clear",
                                  size: "small",
                                  class: "admin-card-btn",
                                  onClick: ($event: any) => (_ctx.openEditModal(t))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_icon, { icon: _ctx.pencilOutline }, null, 8, ["icon"]),
                                    _cache[43] || (_cache[43] = _createTextVNode(" Редактировать ", -1))
                                  ]),
                                  _: 1
                                }, 8, ["onClick"]),
                                _createVNode(_component_ion_button, {
                                  fill: "clear",
                                  size: "small",
                                  class: "admin-card-btn",
                                  onClick: ($event: any) => (_ctx.openQuestionsModal(t))
                                }, {
                                  default: _withCtx(() => [...(_cache[44] || (_cache[44] = [
                                    _createTextVNode(" Вопросы ", -1)
                                  ]))]),
                                  _: 1
                                }, 8, ["onClick"]),
                                _createVNode(_component_ion_button, {
                                  fill: "clear",
                                  size: "small",
                                  class: "admin-card-btn",
                                  onClick: ($event: any) => (_ctx.toggleAssignments(t))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_icon, { icon: _ctx.peopleOutline }, null, 8, ["icon"]),
                                    _cache[45] || (_cache[45] = _createTextVNode(" Назначения ", -1))
                                  ]),
                                  _: 1
                                }, 8, ["onClick"]),
                                _createVNode(_component_ion_button, {
                                  fill: "clear",
                                  color: "danger",
                                  size: "small",
                                  class: "admin-card-btn",
                                  onClick: ($event: any) => (_ctx.deleteTestConfirm(t))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_icon, { icon: _ctx.trashOutline }, null, 8, ["icon"])
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ]),
                              _withDirectives(_createElementVNode("div", _hoisted_5, [
                                _cache[50] || (_cache[50] = _createElementVNode("p", { class: "admin-assignments-title" }, "Кому назначен тест", -1)),
                                (_ctx.currentAssignments.length)
                                  ? (_openBlock(), _createBlock(_component_ion_searchbar, {
                                      key: 0,
                                      modelValue: _ctx.assignmentsFilterQuery,
                                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.assignmentsFilterQuery) = $event)),
                                      placeholder: "Поиск по имени или логину",
                                      debounce: 200,
                                      class: "admin-assignments-search"
                                    }, null, 8, ["modelValue"]))
                                  : _createCommentVNode("", true),
                                (_ctx.assignmentsLoading)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, "Загрузка…"))
                                  : (_ctx.filteredAssignments.length)
                                    ? (_openBlock(), _createBlock(_component_ion_list, {
                                        key: "assign-list",
                                        lines: "full",
                                        class: "admin-assignments-list"
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredAssignments, (a) => {
                                            return (_openBlock(), _createBlock(_component_ion_item, {
                                              key: 'a-' + a.id + '-' + a.userId,
                                              class: "admin-assignment-item"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_ion_label, null, {
                                                  default: _withCtx(() => [
                                                    _createElementVNode("h3", null, _toDisplayString(_ctx.assignmentDisplayName(a)), 1),
                                                    _createElementVNode("p", _hoisted_7, _toDisplayString(a.login), 1),
                                                    _createElementVNode("div", _hoisted_8, [
                                                      (a.passed)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                                                            _createVNode(_component_ion_icon, { icon: _ctx.checkmarkCircle }, null, 8, ["icon"]),
                                                            _cache[46] || (_cache[46] = _createTextVNode(" Пройден ", -1))
                                                          ]))
                                                        : (a.hasDraft)
                                                          ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                                                              _createVNode(_component_ion_icon, { icon: _ctx.createOutline }, null, 8, ["icon"]),
                                                              _cache[47] || (_cache[47] = _createTextVNode(" В процессе ", -1))
                                                            ]))
                                                          : (a.usedAttempts > 0)
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_11, " Не пройден "))
                                                            : (_openBlock(), _createElementBlock("span", _hoisted_12, " Не начат ")),
                                                      _createElementVNode("span", _hoisted_13, "Попыток: " + _toDisplayString(a.usedAttempts), 1),
                                                      (a.lastScore != null)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_14, "Результат: " + _toDisplayString(a.lastScore) + "%", 1))
                                                        : _createCommentVNode("", true)
                                                    ]),
                                                    _createElementVNode("div", _hoisted_15, [
                                                      _createVNode(_component_ion_button, {
                                                        fill: "clear",
                                                        size: "small",
                                                        class: "admin-card-btn",
                                                        onClick: ($event: any) => (_ctx.resetAttempts(t.id, a.userId))
                                                      }, {
                                                        default: _withCtx(() => [...(_cache[48] || (_cache[48] = [
                                                          _createTextVNode("Сбросить попытки", -1)
                                                        ]))]),
                                                        _: 1
                                                      }, 8, ["onClick"]),
                                                      _createVNode(_component_ion_button, {
                                                        fill: "clear",
                                                        color: "danger",
                                                        size: "small",
                                                        class: "admin-card-btn",
                                                        onClick: ($event: any) => (_ctx.removeAssignment(t.id, a.userId))
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_ion_icon, { icon: _ctx.trashOutline }, null, 8, ["icon"])
                                                        ]),
                                                        _: 1
                                                      }, 8, ["onClick"])
                                                    ])
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1024))
                                          }), 128))
                                        ]),
                                        _: 2
                                      }, 1024))
                                    : (_ctx.currentAssignments.length && !_ctx.filteredAssignments.length)
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_16, "Ничего не найдено."))
                                      : (_openBlock(), _createElementBlock("p", _hoisted_17, "Никому не назначен.")),
                                _createVNode(_component_ion_button, {
                                  expand: "block",
                                  fill: "outline",
                                  size: "small",
                                  class: "admin-outline-btn",
                                  onClick: ($event: any) => (_ctx.openAddUsersModal(t))
                                }, {
                                  default: _withCtx(() => [...(_cache[49] || (_cache[49] = [
                                    _createTextVNode("Добавить пользователей", -1)
                                  ]))]),
                                  _: 1
                                }, 8, ["onClick"])
                              ], 512), [
                                [_vShow, _ctx.expandedTestId === t.id]
                              ])
                            ]))
                          }), 128))
                        ]))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["class", "onIonScroll"]),
      _createVNode(_component_ion_modal, {
        "is-open": _ctx.showAddUsersModal,
        onDidDismiss: _ctx.closeAddUsersModal,
        class: "admin-users-modal"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_header, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_toolbar, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_title, null, {
                    default: _withCtx(() => [...(_cache[51] || (_cache[51] = [
                      _createTextVNode("Добавить пользователей", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_ion_buttons, { slot: "end" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        class: "admin-card-btn",
                        onClick: _ctx.closeAddUsersModal
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, { icon: _ctx.closeOutline }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_content, { class: "ion-padding" }, {
            default: _withCtx(() => [
              (_ctx.addUsersModalLoading)
                ? (_openBlock(), _createElementBlock("p", _hoisted_18, "Загрузка списка пользователей…"))
                : (!_ctx.availableUsers.length)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_19, "Нет пользователей для добавления (все уже назначены)."))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createVNode(_component_ion_searchbar, {
                        modelValue: _ctx.addUsersFilterQuery,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.addUsersFilterQuery) = $event)),
                        placeholder: "Поиск по имени, фамилии или логину",
                        debounce: 200,
                        class: "admin-add-users-search"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_ion_list, { lines: "full" }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredAvailableUsers, (u) => {
                            return (_openBlock(), _createBlock(_component_ion_item, {
                              key: u.id,
                              class: "admin-user-pick-item"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_checkbox, {
                                  slot: "start",
                                  checked: _ctx.selectedUserIds.includes(u.id),
                                  onIonChange: ($event: any) => (_ctx.toggleUserPick(u.id))
                                }, null, 8, ["checked", "onIonChange"]),
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => [
                                    _createElementVNode("h3", null, _toDisplayString([u.firstName, u.lastName].filter(Boolean).join(' ').trim() || u.login), 1),
                                    _createElementVNode("p", _hoisted_20, _toDisplayString(u.login), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      }),
                      (_ctx.availableUsers.length && !_ctx.filteredAvailableUsers.length)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_21, "Ничего не найдено."))
                        : _createCommentVNode("", true)
                    ], 64))
            ]),
            _: 1
          }),
          (!_ctx.addUsersModalLoading && _ctx.availableUsers.length)
            ? (_openBlock(), _createBlock(_component_ion_footer, {
                key: 0,
                class: "admin-users-modal-footer"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_toolbar, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_22, [
                        _createVNode(_component_ion_button, {
                          expand: "block",
                          class: "admin-primary-btn",
                          onClick: _ctx.confirmAddUsers,
                          disabled: !_ctx.selectedUserIds.length || _ctx.addingUsers
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.addingUsers ? 'Добавление…' : 'Добавить выбранных'), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick", "disabled"]),
                        _createVNode(_component_ion_button, {
                          expand: "block",
                          fill: "outline",
                          class: "admin-outline-btn",
                          onClick: _ctx.closeAddUsersModal
                        }, {
                          default: _withCtx(() => [...(_cache[52] || (_cache[52] = [
                            _createTextVNode("Отмена", -1)
                          ]))]),
                          _: 1
                        }, 8, ["onClick"])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["is-open", "onDidDismiss"]),
      _createVNode(_component_ion_modal, {
        "is-open": _ctx.showEditModal,
        onDidDismiss: _ctx.closeEditModal,
        class: "admin-edit-test-modal"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_header, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_toolbar, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_title, null, {
                    default: _withCtx(() => [...(_cache[53] || (_cache[53] = [
                      _createTextVNode("Редактировать тест", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_ion_buttons, { slot: "end" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        class: "admin-card-btn",
                        onClick: _ctx.closeEditModal
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, { icon: _ctx.closeOutline }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_content, { class: "ion-padding" }, {
            default: _withCtx(() => [
              (_ctx.editLoading)
                ? (_openBlock(), _createElementBlock("p", _hoisted_23, "Загрузка…"))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_input, {
                          label: "Название",
                          "label-placement": "stacked",
                          modelValue: _ctx.editTest.name,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.editTest.name) = $event)),
                          placeholder: "Название теста"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_input, {
                          label: "Описание (необязательно)",
                          "label-placement": "stacked",
                          modelValue: _ctx.editTest.description,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.editTest.description) = $event)),
                          placeholder: "Описание"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_input, {
                          label: "Порог успешности (%)",
                          "label-placement": "stacked",
                          type: "number",
                          modelValue: _ctx.editTest.passingThreshold,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.editTest.passingThreshold) = $event)),
                          modelModifiers: { number: true },
                          min: "0",
                          max: "100"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_input, {
                          label: "Макс. попыток (пусто = без ограничения)",
                          "label-placement": "stacked",
                          type: "number",
                          modelValue: _ctx.editTest.maxAttempts,
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.editTest.maxAttempts) = $event)),
                          modelModifiers: { number: true },
                          placeholder: "Пусто"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_input, {
                          label: "Время на прохождение (ЧЧ:ММ, пусто = без ограничения)",
                          "label-placement": "stacked",
                          "model-value": (_ctx.editTest.durationForm as unknown as number),
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = (v) => _ctx.onEditTestDurationInput(v)),
                          placeholder: "00:00",
                          maxlength: 5
                        }, null, 8, ["model-value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        (_openBlock(), _createBlock(_component_ion_select, {
                          key: 'edit-roles-' + _ctx.editTestId + '-' + (_ctx.editTest.roleNames || []).join(','),
                          label: "Роли при успешном прохождении",
                          "label-placement": "stacked",
                          modelValue: _ctx.editTest.roleNames,
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.editTest.roleNames) = $event)),
                          multiple: "",
                          interface: "popover",
                          mode: "ios",
                          placeholder: "Выберите роли"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allAuthorities, (a) => {
                              return (_openBlock(), _createBlock(_component_ion_select_option, {
                                key: a.name,
                                value: a.name
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(a.description || a.name), 1)
                                ]),
                                _: 2
                              }, 1032, ["value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"]))
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_24, [
                      _createVNode(_component_ion_button, {
                        expand: "block",
                        class: "admin-primary-btn",
                        onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.saveEditTest())),
                        disabled: !_ctx.editTest.name?.trim() || _ctx.saving
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.saving ? 'Сохранение…' : 'Сохранить'), 1)
                        ]),
                        _: 1
                      }, 8, ["disabled"]),
                      _createVNode(_component_ion_button, {
                        expand: "block",
                        fill: "outline",
                        class: "admin-outline-btn",
                        onClick: _ctx.closeEditModal
                      }, {
                        default: _withCtx(() => [...(_cache[54] || (_cache[54] = [
                          _createTextVNode("Отмена", -1)
                        ]))]),
                        _: 1
                      }, 8, ["onClick"])
                    ])
                  ], 64))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["is-open", "onDidDismiss"]),
      _createVNode(_component_ion_modal, {
        "is-open": _ctx.showQuestionsModal,
        onDidDismiss: _ctx.closeQuestionsModal,
        class: "admin-questions-modal"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_header, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_toolbar, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_title, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Вопросы и ответы" + _toDisplayString(_ctx.questionsTestName ? ': ' + _ctx.questionsTestName : ''), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_buttons, { slot: "end" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        class: "admin-card-btn",
                        onClick: _ctx.closeQuestionsModal
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, { icon: _ctx.closeOutline }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_content, { class: "ion-padding admin-questions-content" }, {
            default: _withCtx(() => [
              (_ctx.questionsLoading)
                ? (_openBlock(), _createElementBlock("p", _hoisted_25, "Загрузка…"))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (_ctx.showAddQuestionForm)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                          _cache[58] || (_cache[58] = _createElementVNode("p", { class: "admin-assignments-title" }, "Новый вопрос", -1)),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_input, {
                                label: "Текст вопроса",
                                "label-placement": "stacked",
                                modelValue: _ctx.newQuestion.text,
                                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.newQuestion.text) = $event)),
                                placeholder: "Введите вопрос"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_checkbox, {
                                labelPlacement: "end",
                                modelValue: _ctx.newQuestion.multipleChoice,
                                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.newQuestion.multipleChoice) = $event))
                              }, {
                                default: _withCtx(() => [...(_cache[55] || (_cache[55] = [
                                  _createTextVNode("Несколько правильных ответов", -1)
                                ]))]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_input, {
                                label: "Порядок (число)",
                                "label-placement": "stacked",
                                type: "number",
                                modelValue: _ctx.newQuestion.sortOrder,
                                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.newQuestion.sortOrder) = $event)),
                                modelModifiers: { number: true },
                                placeholder: "0"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createElementVNode("div", _hoisted_27, [
                            _createVNode(_component_ion_button, {
                              size: "small",
                              class: "admin-primary-btn",
                              onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.saveNewQuestion())),
                              disabled: !_ctx.newQuestion.text?.trim() || _ctx.saving
                            }, {
                              default: _withCtx(() => [...(_cache[56] || (_cache[56] = [
                                _createTextVNode("Сохранить вопрос", -1)
                              ]))]),
                              _: 1
                            }, 8, ["disabled"]),
                            _createVNode(_component_ion_button, {
                              size: "small",
                              fill: "outline",
                              class: "admin-outline-btn",
                              onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.cancelAddQuestion()))
                            }, {
                              default: _withCtx(() => [...(_cache[57] || (_cache[57] = [
                                _createTextVNode("Отмена", -1)
                              ]))]),
                              _: 1
                            })
                          ])
                        ]))
                      : (_openBlock(), _createBlock(_component_ion_button, {
                          key: 1,
                          expand: "block",
                          size: "small",
                          class: "admin-primary-btn",
                          onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.showAddQuestionForm = true))
                        }, {
                          default: _withCtx(() => [...(_cache[59] || (_cache[59] = [
                            _createTextVNode("+ Добавить вопрос", -1)
                          ]))]),
                          _: 1
                        })),
                    (_ctx.questionsList.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questionsList, (q) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: q.id,
                              class: "admin-question-block"
                            }, [
                              _createElementVNode("div", _hoisted_29, [
                                _createElementVNode("div", _hoisted_30, [
                                  _createElementVNode("strong", null, _toDisplayString(q.text || '(без текста)'), 1),
                                  (q.multipleChoice)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_31, "несколько"))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("span", _hoisted_32, "порядок: " + _toDisplayString(q.sortOrder ?? 0), 1)
                                ]),
                                _createElementVNode("div", _hoisted_33, [
                                  _createVNode(_component_ion_button, {
                                    fill: "clear",
                                    size: "small",
                                    class: "admin-card-btn",
                                    onClick: ($event: any) => (_ctx.startEditQuestion(q))
                                  }, {
                                    default: _withCtx(() => [...(_cache[60] || (_cache[60] = [
                                      _createTextVNode("Изменить", -1)
                                    ]))]),
                                    _: 1
                                  }, 8, ["onClick"]),
                                  _createVNode(_component_ion_button, {
                                    fill: "clear",
                                    color: "danger",
                                    size: "small",
                                    class: "admin-card-btn",
                                    onClick: ($event: any) => (_ctx.deleteQuestionConfirm(q))
                                  }, {
                                    default: _withCtx(() => [...(_cache[61] || (_cache[61] = [
                                      _createTextVNode("Удалить", -1)
                                    ]))]),
                                    _: 1
                                  }, 8, ["onClick"])
                                ])
                              ]),
                              (_ctx.editQuestionId === q.id)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                    _createVNode(_component_ion_item, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_input, {
                                          label: "Текст вопроса",
                                          "label-placement": "stacked",
                                          modelValue: _ctx.editQuestionForm.text,
                                          "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.editQuestionForm.text) = $event)),
                                          placeholder: "Введите вопрос"
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_ion_item, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_checkbox, {
                                          labelPlacement: "end",
                                          modelValue: _ctx.editQuestionForm.multipleChoice,
                                          "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.editQuestionForm.multipleChoice) = $event))
                                        }, {
                                          default: _withCtx(() => [...(_cache[62] || (_cache[62] = [
                                            _createTextVNode("Несколько правильных ответов", -1)
                                          ]))]),
                                          _: 1
                                        }, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_ion_item, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_input, {
                                          label: "Порядок",
                                          "label-placement": "stacked",
                                          type: "number",
                                          modelValue: _ctx.editQuestionForm.sortOrder,
                                          "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.editQuestionForm.sortOrder) = $event)),
                                          modelModifiers: { number: true }
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_ion_button, {
                                      size: "small",
                                      class: "admin-primary-btn",
                                      onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.saveEditQuestion())),
                                      disabled: _ctx.saving
                                    }, {
                                      default: _withCtx(() => [...(_cache[63] || (_cache[63] = [
                                        _createTextVNode("Сохранить", -1)
                                      ]))]),
                                      _: 1
                                    }, 8, ["disabled"]),
                                    _createVNode(_component_ion_button, {
                                      size: "small",
                                      fill: "outline",
                                      class: "admin-outline-btn",
                                      onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.editQuestionId = null))
                                    }, {
                                      default: _withCtx(() => [...(_cache[64] || (_cache[64] = [
                                        _createTextVNode("Отмена", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("ul", _hoisted_35, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((q.answers || []), (ans) => {
                                  return (_openBlock(), _createElementBlock("li", {
                                    key: ans.id,
                                    class: "admin-answer-row"
                                  }, [
                                    _createElementVNode("span", _hoisted_36, _toDisplayString(ans.text), 1),
                                    (ans.isCorrect)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_37, "верный"))
                                      : _createCommentVNode("", true),
                                    (_ctx.editAnswerId === ans.id)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          _createVNode(_component_ion_input, {
                                            modelValue: _ctx.editAnswerForm.text,
                                            "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.editAnswerForm.text) = $event)),
                                            placeholder: "Текст ответа",
                                            class: "admin-answer-input"
                                          }, null, 8, ["modelValue"]),
                                          _createVNode(_component_ion_checkbox, {
                                            modelValue: _ctx.editAnswerForm.isCorrect,
                                            "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.editAnswerForm.isCorrect) = $event)),
                                            labelPlacement: "end",
                                            class: "admin-answer-checkbox"
                                          }, {
                                            default: _withCtx(() => [...(_cache[65] || (_cache[65] = [
                                              _createTextVNode("Верный", -1)
                                            ]))]),
                                            _: 1
                                          }, 8, ["modelValue"]),
                                          _createVNode(_component_ion_button, {
                                            size: "small",
                                            class: "admin-primary-btn",
                                            onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.saveEditAnswer())),
                                            disabled: _ctx.saving
                                          }, {
                                            default: _withCtx(() => [...(_cache[66] || (_cache[66] = [
                                              _createTextVNode("Сохранить", -1)
                                            ]))]),
                                            _: 1
                                          }, 8, ["disabled"]),
                                          _createVNode(_component_ion_button, {
                                            size: "small",
                                            fill: "outline",
                                            class: "admin-outline-btn",
                                            onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.editAnswerId = null))
                                          }, {
                                            default: _withCtx(() => [...(_cache[67] || (_cache[67] = [
                                              _createTextVNode("Отмена", -1)
                                            ]))]),
                                            _: 1
                                          })
                                        ], 64))
                                      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                          _createVNode(_component_ion_button, {
                                            fill: "clear",
                                            size: "small",
                                            class: "admin-card-btn",
                                            onClick: ($event: any) => (_ctx.startEditAnswer(ans))
                                          }, {
                                            default: _withCtx(() => [...(_cache[68] || (_cache[68] = [
                                              _createTextVNode("Изменить", -1)
                                            ]))]),
                                            _: 1
                                          }, 8, ["onClick"]),
                                          _createVNode(_component_ion_button, {
                                            fill: "clear",
                                            color: "danger",
                                            size: "small",
                                            class: "admin-card-btn",
                                            onClick: ($event: any) => (_ctx.deleteAnswerConfirm(ans))
                                          }, {
                                            default: _withCtx(() => [...(_cache[69] || (_cache[69] = [
                                              _createTextVNode("Удалить", -1)
                                            ]))]),
                                            _: 1
                                          }, 8, ["onClick"])
                                        ], 64))
                                  ]))
                                }), 128)),
                                (_ctx.addAnswerForQid === q.id)
                                  ? (_openBlock(), _createElementBlock("li", _hoisted_38, [
                                      _createVNode(_component_ion_input, {
                                        modelValue: _ctx.newAnswer.text,
                                        "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.newAnswer.text) = $event)),
                                        placeholder: "Текст ответа",
                                        class: "admin-answer-input"
                                      }, null, 8, ["modelValue"]),
                                      _createVNode(_component_ion_checkbox, {
                                        modelValue: _ctx.newAnswer.isCorrect,
                                        "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.newAnswer.isCorrect) = $event)),
                                        labelPlacement: "end"
                                      }, {
                                        default: _withCtx(() => [...(_cache[70] || (_cache[70] = [
                                          _createTextVNode("Верный", -1)
                                        ]))]),
                                        _: 1
                                      }, 8, ["modelValue"]),
                                      _createVNode(_component_ion_button, {
                                        size: "small",
                                        class: "admin-primary-btn",
                                        onClick: ($event: any) => (_ctx.saveNewAnswer(q.id)),
                                        disabled: !_ctx.newAnswer.text?.trim() || _ctx.saving
                                      }, {
                                        default: _withCtx(() => [...(_cache[71] || (_cache[71] = [
                                          _createTextVNode("Добавить", -1)
                                        ]))]),
                                        _: 1
                                      }, 8, ["onClick", "disabled"]),
                                      _createVNode(_component_ion_button, {
                                        size: "small",
                                        fill: "outline",
                                        class: "admin-outline-btn",
                                        onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.cancelAddAnswer()))
                                      }, {
                                        default: _withCtx(() => [...(_cache[72] || (_cache[72] = [
                                          _createTextVNode("Отмена", -1)
                                        ]))]),
                                        _: 1
                                      })
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              (_ctx.addAnswerForQid !== q.id)
                                ? (_openBlock(), _createBlock(_component_ion_button, {
                                    key: 1,
                                    size: "small",
                                    fill: "outline",
                                    class: "admin-outline-btn admin-add-answer-btn",
                                    onClick: ($event: any) => (_ctx.startAddAnswer(q))
                                  }, {
                                    default: _withCtx(() => [...(_cache[73] || (_cache[73] = [
                                      _createTextVNode("+ Добавить ответ", -1)
                                    ]))]),
                                    _: 1
                                  }, 8, ["onClick"]))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ]))
                      : (!_ctx.showAddQuestionForm)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_39, "Вопросов пока нет. Добавьте первый вопрос."))
                        : _createCommentVNode("", true)
                  ], 64))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["is-open", "onDidDismiss"])
    ]),
    _: 1
  }))
}